import ArticulosTableLoader from 'components/Loaders/ArticulosTableLoader'
import { useGetAllMatriculasByProject } from 'lib/react-query/queriesModuloType'
import { useConfigMatriculas } from 'context/ConfigMatriculasContext'
import ConfigMatriculasTable_v2 from './ConfigMatriculasTable_v2'

const ConfigMatriculasTable = () => {
  const { data, isLoading, isFetching } = useGetAllMatriculasByProject()
  const { textFieldValue } = useConfigMatriculas()

  if (isLoading || !data) return <ArticulosTableLoader />

  return (
    <div
      className="fabrica-matriculas-table-container"
      style={{ flex: 1, overflowY: 'auto', marginTop: '1rem' }}
    >
      <ConfigMatriculasTable_v2 />
      
    </div>
  )
}

export default ConfigMatriculasTable
